import CircleSolid from '../media/CircleSolid.svg';
import CircleDotted from '../media/CircleDotted.svg';
import DiamondSolid from '../media/DiamondSolid.svg';
import DiamondDotted from '../media/DiamondDotted.svg';

export const getFluctuationGridCellStyle = ({ palette = {} }) => ({
  '& .performance-metrics-value': {
    width: 'calc(100% - 20px)',
    float: 'left',
  },
  '& .performance-metrics-fluctuation, & .performance-metrics-insight': {
    width: 20,
    '& .iconba-Insights': {
      color: palette.themePrimary,
    },
  },
});

export const getFluctuationTooltipStyle = () => ({
  '#fluctuation-tooltip-id .popover-content': {
    padding: '5px 10px',
  },
});

export const getFluctuationContentStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .fluc-lightbulb': {
    color: palette.themePrimary,
    '&:before': {
      content: '"\\E3AF"',
      fontFamily: iconFontFamily,
      fontSize: 16,
    },
  },
  '& .fluctuation-upper-content': {
    padding: '10px 15px 0',
  },
  '& .fluctuation-upper-content .fluctuation-close': {
    position: 'absolute',
    right: 10,
    top: 10,
  },
  '& .fluctuation-lower-content': {
    paddingLeft: 10,
    paddingRight: 10,

    '& .checkbox-container': {
      backgroundColor: 'unset',

      '& .checkbox': {
        margin: '0 0 10px 0',

        '& input': {
          marginLeft: 0,
          marginRight: 5,
          verticalAlign: 'bottom',
        },
      },

      '& .ms-Checkbox-text': {
        fontSize: 12,
      },
    },

    '& .confirm-container .button-container': {
      paddingLeft: 10,
    },

    '& .btn-default': {
      marginLeft: 10,
    },
  },
  '& .fluctuation-button-container': {
    marginTop: 10,
  },
  '& .cause-container-wrapper': {
    backgroundColor: '#E5F5FB',
    borderTop: '1px solid #1570A6',
    borderBottom: '1px solid #1570A6',
    marginTop: 10,
    padding: '5px 15px',
    display: 'flex',
    alignItems: 'center',
  },
  '& .cause-container-wrapper .fluc-description': {
    display: 'inline',
    fontFamily: '\'Arial Regular\'',
    color: '#1570A6',
    marginLeft: 5,
  },

  '& .cause-container-wrapper .action-container': {
    fontSize: 11,
  },

  '& .inline-block': {
    display: 'inline-block',
  },
  '& .metric-entry': {
    display: 'inline-block',
    marginRight: 20,
  },
  '& .metric-counter-container': {
    paddingTop: '12px !important',
  },
  '& .metric-entry .metric-color-line': {
    width: '20px !important',
    height: '40px !important',
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'center',
    backgroundPositionY: 'center',
  },
  '& .metric-entry .metric-counter-text-wrapper': {
    float: 'right',
    '& .metric-text': {
      verticalAlign: 'top',
      fontSize: 14,
      top: 0,
      height: '50%',
      display: 'inherit',
    },
    '& .metric-value': {
      color: palette.themePrimary,
      bottom: 0,
      verticalAlign: 'bottom',
      height: '50%',
      fontSize: 15,
      fontWeight: 'bold',
      display: 'inherit',
    },
  },

  '& .metric-entry .iconba.iconba-Insights': {
    color: palette.themePrimary,
  },

  '& .metric-entry .primary': {
    backgroundImage: `url("${CircleSolid}")`,
  },
  '& .metric-entry .secondary': {
    backgroundImage: `url("${DiamondSolid}")`,
  },
  '& .metric-entry .primaryComparison': {
    backgroundImage: `url("${CircleDotted}")`,
  },
  '& .metric-entry .secondaryComparison': {
    backgroundImage: `url("${DiamondDotted}")`,
  },

  '& .fluctuation-action-container': {
    padding: 5,
    marginTop: 10,
  },
  '& .fluctuation-action-container .confirm-container .confirm-message': {
    marginBottom: 5,
    paddingLeft: 10,
  },
  '& .fluctuation-action-container .show': {
    display: 'block',
  },
  '& .fluctuation-action-container .hide': {
    display: 'none',
  },
  '& .fluctuation-action-container .feedback-complete': {
    textAlign: 'center',
    color: 'green',
    fontSize: 12,
  },
  '& .fluctuation-action-container .action-container': {
    marginBottom: 10,
    textAlign: 'center',
  },
  '& .fluctuation-action-container .action-container button': {
    background: 'transparent',
    border: 'none',
    outline: 'transparent',
    padding: '0',
  },
  '& .fluctuation-action-container .action-container .fluc-image': {
    marginTop: 5,
  },
  '& .fluctuation-action-container .action-container .HelpTopic, .fluctuation-action-container .action-container .link-text': {
    cursor: 'pointer',
    color: palette.themePrimary,
    marginLeft: 5,
    marginRight: 5,
    fontSize: 11,
  },
  '& .fluctuation-action-container .form-container': {
    padding: 10,
  },
  '& .fluctuation-action-container .form-container label': {
    fontSize: 12,
    color: '#333333',
  },
  '& .fluctuation-action-container .form-container .comment-container .comment-textarea': {
    resize: 'none',
    width: '100%',
    height: 75,
  },
  '& .action-container-wrapper': {
    padding: '10px 20px 0 20px',
  },
  '& .action-container-wrapper .action-header': {
    fontWeight: 'bold',
    marginTop: 5,
    marginBottom: 5,
  },
  '& .action-container-wrapper .action-list-item': {
    display: 'list-item',
    marginLeft: '1.3em',
    wordWrap: 'break-word',

    '&.nested-item': {
      marginLeft: '2.6em',
      listStyleType: 'circle',
    },
  },
  '& .action-container-wrapper .entity-item-wrapper': {
    display: 'inline-block',
  },
  '& .action-container-wrapper .cause-item-segment': {
    display: 'inline',
  },
  '& .action-container-wrapper .entity-item': {
    color: palette.themePrimary,
    display: 'inline-block',
    cursor: 'pointer',
    background: 'transparent',
    border: 'none',
    outline: 'none',
    padding: '0',
  },
  '& .detail-container-wrapper': {
    width: '100%',
    maxHeight: 126,
    border: 'none',
    marginTop: 10,
    marginBottom: 10,
    padding: 5,
    backgroundColor: '#f2f2f2',
    overflowY: 'auto',
  },
  '& .detail-container-wrapper .entity-header': {
    fontWeight: 'bold',
  },
  '& .detail-container-wrapper .entity-entry': {
    marginTop: 5,
  },

  // view all button
  '& .viewall-container-wrapper': {
    marginTop: 10,
    marginLeft: 24,
    marginBottom: 10,
  },

  // pagination dots
  '& .pagination-container .fluctuation-pagination': {
    width: 8,
    height: 8,
    borderRadius: 8,
    margin: '10px 0 10px 10px',
    display: 'inline-block',
    border: '1px solid #605E5C',
    backgroundColor: '#fff',
    padding: '0',
    cursor: 'pointer',
  },
  '& .pagination-container .active': {
    backgroundColor: palette.themePrimary,
    border: `1px solid ${palette.themePrimary}`,
  },

  // pagination carousel
  '& .pagination-container': {
    paddingLeft: 16,
    '& div:first-child': {
      float: 'left',
    },
  },

  '& .card-holder__wrapper': {
    float: 'right',
    marginBottom: 10,

    '& div': {
      float: 'none !important',
    },
  },

  '& .card-holder__wrapper .carousel-control': {
    backgroundColor: 'transparent',
    textShadow: 'none',
    color: palette.themePrimary,
    opacity: 1,
    height: 24,
    marginRight: 20,
    position: 'relative',
    fontSize: 16,
    display: 'inline-block',
    top: 0,
    marginTop: 0,

    '&[role="button"]': {
      '&:hover': {
        color: palette.themeDarker,
        backgroundColor: palette.neutralLighter,
      },
      '&:focus': {
        border: `1px solid ${palette.neutralSecondary}`,
      },
      '&:active': {
        backgroundColor: palette.neutralLight,
      },
      '&:focus:after': {
        border: 'none',
      },
    },

    '&[role="button"][disabled]:hover': {
      backgroundColor: 'transparent !important',
    },
  },

  '& .card-holder__wrapper .carousel-control[disabled] .carousel-control': {
    color: palette.neutralTertiaryAlt,
    cursor: 'default',

    '&:hover': {
      color: palette.neutralTertiaryAlt,
    },
    '&:focus:after, &:focus': {
      border: 'none',
    },
  },

  '& .carousel-control .carousel-control__arrow-left:before': {
    content: '"\\E76B"',
    fontFamily: iconFontFamily,
  },

  '& .carousel-control .carousel-control__arrow-right:before': {
    content: '"\\E76C"',
    fontFamily: iconFontFamily,
  },
});

export const getFluctuationLoadingStyle = () => ({
  '.bingads-fluctuation-callout .fluctuation-loading': {
    display: 'flex',

    '& .loading-dialog': {
      position: 'relative',
      border: 'none',
      boxShadow: 'none',
      top: 0,
      right: 0,
      maxHeight: 135,
      maxWidth: 200,
    },
  },
});

export const getFluctuationPopupStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '.bingads-fluctuation-callout': {
    maxWidth: 500,

    '& .popover-content': {
      padding: 0,
      maxHeight: 680,
      overflowY: 'auto',
      overflowX: 'hidden',

      '& a:focus, & button:not(.btn):focus': {
        border: '1px solid #605E5C !important',
      },

      '& button:not(.btn):hover': {
        backgroundColor: `${palette.neutralLighter} !important`,
      },

      '& a:hover': {
        textDecoration: 'underline',
        color: `${palette.themeDarker} !important`,
      },
    },
    '& .bingads-fluctuation-wrapper': {
      ...getFluctuationContentStyle({ palette, iconFontFamily }),
    },
  },
});
